import { useAtomValue } from "jotai";
import { readStoredPilotGoal } from "web_myplann/Infrastructure/Utils/readStoredPilotGoal";
import { rightsState } from "web_myplann/Shared/State/rightsAtom";

export const usePilotThemeEnabled = () => {
	const pilotGoal = useAtomValue(rightsState)?.pilotGoal;
	return pilotGoal ?? readStoredPilotGoal();
};
